// tslint:disable: max-line-length
import React, { useEffect, useState, useRef } from 'react';
import { getItem, setItem } from '../../utils/localStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import ControlSelect from 'lqa-ui/lib/Components/ControlSelect';
import ControlTextarea from 'lqa-ui/lib/Components/ControlTextarea';
import { Modal } from './../../app/common/sharedComponents/Modal';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { Headline3, Body5, Body6 } from './../../app/common/typography';
import {
  createActionPlan,
  getAssessments,
  getFocusAreaOptions,
  getFocusAreaOptionsDefault,
  getSelfAssessmentDetails,
} from './../../requests/actionPlan';
import moment from 'moment';
import { ActionPlanType } from './../../enums/ActionPlanType';
import { translateActionPlanTypeLabel } from './../../enums/labels/actionPlanTypeLabel';
import { uploadActionPlanAttachment } from '../../components/EditActionPlan/apiCaller';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import { uniqBy } from 'lodash';
import { StandardMultiSelect } from '../../components/commons/StandardMultiSelect/StandardMultiSelect';
import Tags from 'lqa-ui/lib/Components/Tags';
import { translateActionPlanMeasurementTypeLabel } from './../../enums/labels/actionPlanMeasurementTypeLabel';
import { ActionPlanMeasurementType } from './../../enums/ActionPlanMeasurementType';
import { AssessmentType } from '../../enums/AssessmentType';
import { getCustomScores } from '../Dashboard/apiCaller';
import Skeleton from 'react-loading-skeleton';
import ImageOverlay from 'lqa-ui/lib/Components/ImageOverlay';
import ImageResizeBasic from '../../helpers/ImageResizeBasic';
import axios from 'axios';
import {
  castSelectedDateWithoutConversion,
  convertUTCDateDisplay,
} from '../../helpers/dates';
import { isUnauthorized } from '../../utils/common';
import { gethasAssessment } from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import {
  ContentArea,
  ModalTitleContainer,
  TitleAttachFileModal,
  Borderbox,
  RequiredIcon,
  AssessmentTypeTable,
  OwnerTable,
  TextPill,
  Table,
  AddAttachmentsText,
  DeleteIconContainer,
  FileNameContainer,
  GridContent,
  GridItem,
  Thumbnail,
} from './CreateActionPlan.styled';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { CloseCircle } from '../../app/common/icons/CloseCircle';
import { sentryReport } from '../../helpers/sentry';
import {
  getWithoutAssessmentLabel,
  WithoutAssessment,
} from '../../enums/WithoutAssessment';
import { FocusAreaSelect } from './FocusAreaSelect';
import { SearchBoxActionPlanUsers } from '../CreateActionPlan/SearchBoxActionPlanUsers';
import { CustomScoreTypes, ICustomScoreType } from '../../app/@types/customScores';

const CreateActionPlan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDefault, setIsDefault] = useState(false);
  const loc: any = { ...location };
  const {
    actionPlanData,
    sourceTemplateCategoryId,
    selectedStandards,
    imageAttachments,
    selfAssessmentId,
    visit,
  } = loc.state;
  let defaultId;
  let assId;
  if (actionPlanData && actionPlanData.sourceTemplateCategoryId) {
    defaultId = actionPlanData.sourceTemplateCategoryId;
    assId = actionPlanData.selectedAssessment;
  }
  if (sourceTemplateCategoryId) {
    defaultId = sourceTemplateCategoryId;
  }
  let parentId;
  if (
    actionPlanData &&
    actionPlanData.id &&
    !actionPlanData.sourceTemplateCategoryId
  ) {
    parentId = actionPlanData.id;
  }
  const [
    isConfirmProceedWithoutAssessmentModal,
    setConfirmProceedWithoutAssessmentModal,
  ] = useState(false);
  const [isAttachFileModal, setAttachFileModal] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [actionPlanIds, setActionPlanIds] = useState<number[]>();
  const [assignees, setAssignees] = React.useState<any>([]);
  const [assessmentType, setAssessmentType] = useState(
    selfAssessmentId ? 'self' : 'LQA'
  );
  const [assessments, setAssessments] = useState<any>([]);
  const [selectedAssessment, setSelectedAssessment] = useState<any>(undefined);
  const [selectedStandardType, setSelectedStandardType] = useState<CustomScoreTypes>('LQA');
  const [customStandardTypes, setCustomStandardTypes] = useState<ICustomScoreType[]>([]);
  const [selectedFocusArea, setSelectedFocusArea] = useState<any>(defaultId);
  const [selectedVisit, setSelectedVisit] = useState<number>(visit || 1);
  const [focusAreaOptions, setFocusAreaOptions] = useState<any>([]);
  const [actionPlanType, setActionPlanType] = useState('');
  const [actionPlanMeasurement, setActionPlanMeasurement] = useState('');
  const [messageTitle, setMessageTitle] = useState('');
  const [dueDate, setDueDate] = useState<any>(null);
  const [messageDescription, setMessageDescription] = useState('');
  const [selectedTemplateId, setSelectedTemplateId] = useState<any>(undefined);
  const [standards, setStandards] = useState<any[]>([]);
  const [missedStandards, setMissedStandards] = useState<any[]>([]);
  const [isCreating, setIsCreating] = useState(false);
  const [reservationPresent, setReservationPresent] = useState(false);
  const [errorState, setErrorState] = useState({
    assignees: false,
    assessmentType: false,
    actionPlanType: false,
    actionPlanMeasurement: false,
    messageTitle: false,
    dueDate: false,
    missedStandards: false,
    messageDescription: false,
  });
  const [attachments, setAttachments] = useState<any>([]);

  const inputRef = useRef<any>('');
  const userData = getItem('user');
  const hasAssessment = gethasAssessment();
  const selectedHotel = getItem('selectedHotel');
  const [selfStayStart, setSelfStayStart] = useState('');
  const { t } = useTranslation();

  const handleAssignees = (updatedAssignee) => {
    setAssignees(updatedAssignee);
  };

  async function createFile (url) {
    const response = await axios.get(url, { responseType: 'blob' });

    const blob = new Blob([response.data]);

    // Create File from Blob
    const fileName = `${Date.now()}.jpeg`;
    const file = new File([blob], fileName, { type: 'image/jpeg' });

    return file;
  }

  useEffect(() => {
    if (imageAttachments && imageAttachments.length > 0) {
      convertImagesToFileObject(imageAttachments);
    }
  }, [imageAttachments]);

  // convert images to fileReader
  const convertImagesToFileObject = async (attachments) => {
    const temp: any = [];

    for (const item of attachments) {
      const file = await createFile(item.url);
      temp.push(file);
    }

    if (temp && temp.length > 0) {
      setAttachments(temp);
    }
  };

  useEffect(() => {
    getAssessments()
      .then((response) => {
        if (
          response &&
          response.results.filter((o) => o.assessmentType === 'reservation')
            .length > 0
        ) {
          setReservationPresent(true);
        }
        if (selfAssessmentId) {
          getSelfAssessmentDetails(selfAssessmentId).then((res) => {
            if (res) {
              setSelfStayStart(res.stayStart);
            }
          });
        }
        setAssessments(response);
        let selectedId = response.results[0].id;
        let selectedTId = response.results[0].templateId;
        if (assId) {
          // tslint:disable-next-line:triple-equals
          const d = response.results.find((res) => res.stayStart == assId);
          if (d) {
            selectedId = d.id;
            selectedTId = d.templateId;
          }
        }
        setSelectedAssessment(selectedId);
        setSelectedTemplateId(selectedTId);
      })
      .catch((err) => {
        if (hasAssessment) {
          showErrorMessage(
            'Could not find Assessment Data',
            !isUnauthorized(err)
          );
        }
      });
    localStorage.setItem('id', 'actionPlan');
    if (selectedHotel) {
      getCustomScores(selectedHotel)
        .then((response) => {
          setCustomStandardTypes(response);
          setSelectedStandardType(response[0].customScoreType);
        })
        .catch((err) => {
          showErrorMessage(
            'Could not find Custom Standard Types',
            !isUnauthorized(err)
          );
        });
    }
  }, []);
  useEffect(() => {
    setFocusAreaOptions([]);
    if (
      selectedAssessment &&
      selectedTemplateId &&
      selectedStandardType &&
      !isDefault
    ) {
      getFocusAreaOptions(
        selfAssessmentId ? selfAssessmentId : selectedAssessment,
        selectedTemplateId,
        selectedStandardType
      )
        .then((response) => {
          setFocusAreaOptions(response);
        })
        .catch((err) => {
          showErrorMessage(
            'Could load Focus Area Options',
            !isUnauthorized(err)
          );
        });
    } else {
      getFocusAreaOptionsDefault()
        .then((res) => {
          setFocusAreaOptions({ categories: res });
        })
        .catch((err) => {
          showErrorMessage(
            'Could load Focus Area Options',
            !isUnauthorized(err)
          );
        });
    }
  }, [selectedAssessment, selectedStandardType, isDefault]);

  useEffect(() => {
    if (
      focusAreaOptions &&
      focusAreaOptions.categories &&
      selectedFocusArea &&
      ((actionPlanData &&
          actionPlanData.selectedStandards &&
          actionPlanData.selectedStandards.length > 0) ||
        selectedStandards)
    ) {
      const categoryD =
        focusAreaOptions &&
        focusAreaOptions.categories &&
        focusAreaOptions.categories.find(
          (category) =>
            category.categoryId.toString() === selectedFocusArea.toString() &&
            category.visit === visit
        );
      const optD = categoryD ? categoryD.missedStandards : undefined;
      let stds =
        actionPlanData &&
        actionPlanData.selectedStandards[0] &&
        optD.filter(
          (o) => o.standardId === actionPlanData.selectedStandards[0].standardId
        );
      if (selectedStandards && selectedStandards.length > 0) {
        stds = optD.filter(
          (o) => o.standardId === selectedStandards[0].standardId
        );
      }
      setStandards(stds);
      setMissedStandards(
        stds.map((standard) => {
          opt = opt.map((o) => {
            if (o.standardId !== standard.standardId) {
              o.selected = false;
            }
            return o;
          });

          return {
            standardId: standard.standardId,
            categoryId: standard.categoryId,
          };
        })
      );
    }
  }, [focusAreaOptions]);

  const getImages = (a) => {
    return [{ source: URL.createObjectURL(a), notes: a.name || a.notes }];
  };

  const handleAttachmentUpload = (actionPlanIds) => {
    if (attachments && attachments.length > 0) {
      actionPlanIds.map((actionPlanId, apIndex) => {
        for (const [fileIndex, file] of attachments.entries()) {
          const formData = new FormData();
          formData.append('file', file);
          uploadActionPlanAttachment(actionPlanId, formData)
            .then((response) => {
              if (response) {
                if (
                  fileIndex === attachments.length - 1 &&
                  apIndex === actionPlanIds.length - 1
                ) {
                  setIsLoading(false);
                  setConfirmProceedWithoutAssessmentModal(false);
                  setIsCreating(false);
                  setItem('isFormData', false);
                  localStorage.setItem('action', 'individual');
                  showSuccessMessage(
                    t(
                      'COMMON.ACTION_PLAN.ALERT_MESSAGES.ACTION_PLAN_CREATED_SUCCESSFULLY'
                    )
                  );
                  navigate(`/actionPlanList?viewType=sent&overDue=false`);
                }
              }
            })
            .catch((e) => {
              showErrorMessage(t('COMMON.ALERT_MESSAGES.ATTACHMENT_ERROR'));
              setIsLoading(false);
              setConfirmProceedWithoutAssessmentModal(false);
              setIsCreating(false);
              setItem('isFormData', false);
              setAttachFileModal(true);
            });
        }
      });
    } else {
      setIsLoading(false);
      setConfirmProceedWithoutAssessmentModal(false);
      setIsCreating(false);
      setItem('isFormData', false);
      localStorage.setItem('action', 'individual');
      showSuccessMessage(
        t('COMMON.ACTION_PLAN.ALERT_MESSAGES.ACTION_PLAN_CREATED_SUCCESSFULLY')
      );
      navigate(`/actionPlanList?viewType=sent&overDue=false`);
    }
  };

  const handleSubmit = () => {
    setIsLoading(true);
    const selectedHotel = getItem('selectedHotel');
    const selectedBrand = getItem('selectedBrand');
    if (
      !assignees.length ||
      !selectedBrand ||
      !actionPlanType ||
      !actionPlanMeasurement ||
      !dueDate ||
      !missedStandards ||
      !messageTitle ||
      !messageDescription
    ) {
      setIsLoading(false);
      setConfirmProceedWithoutAssessmentModal(false);
      showErrorMessage('Please fill all required fields.');
      setErrorState({
        assignees: assignees.length <= 0 ? true : false,
        assessmentType: !assessmentType ? true : false,
        actionPlanType: !actionPlanType ? true : false,
        actionPlanMeasurement: !actionPlanMeasurement ? true : false,
        messageTitle: !messageTitle ? true : false,
        dueDate: !dueDate ? true : false,
        missedStandards: !missedStandards ? true : false,
        messageDescription: !messageDescription ? true : false,
      });
      return;
    }
    for (const file of attachments) {
      const actionPlanFileSize = getItem('actionPlanFileSize') || 500000000;
      if (!file || file.size > actionPlanFileSize) {
        showErrorMessage(' Invalid file.Please check file size or file type.');
        setIsCreating(false);
        setIsLoading(false);
        setConfirmProceedWithoutAssessmentModal(false);
        return;
      }
    }
    setIsCreating(true);
    const payLoad: any = {
      brandId: selectedBrand,
      hotelId: selectedHotel,
      parentId,
      assignToType: 'user',
      assigneeId: assignees.map((assignee) => assignee.id),
      focusAreaCategoryId: parseInt(selectedFocusArea),
      actionPlanType,
      measurement: actionPlanMeasurement,
      messageTitle,
      description: messageDescription,
      deadline: dueDate,
      missedStandards,
      standardType: selectedStandardType,
      visit: selectedVisit != null ? selectedVisit : 1,
      isDefault,
    };
    if (hasAssessment) {
      payLoad.assessmentId = parseInt(selfAssessmentId || selectedAssessment);
    }
    createActionPlan(payLoad)
      .then(async (response) => {
        const createdActionPlanId = response.map((actionPlan) => actionPlan.id);
        setActionPlanIds(createdActionPlanId);
        await handleAttachmentUpload(createdActionPlanId);
      })
      .catch((error) => {
        sentryReport(error.response.data, error.message, error.code, {
          alertMessage: t(
            'COMMON.ALERT_MESSAGES.PLEASE_FILL_ALL_REQUIRED_FIELDS'
          ),
          method: 'CreateActionPlan',
          payload: payLoad,
        });
        showErrorMessage(
          t('COMMON.ALERT_MESSAGES.PLEASE_FILL_ALL_REQUIRED_FIELDS')
        );
        setIsCreating(false);
        setIsLoading(false);
        setConfirmProceedWithoutAssessmentModal(false);
      });
  };

  const formChangeHandler = () => {
    setItem('isFormData', true);
  };

  const AttachmentContainer = (file) => {
    return (
      <>
        <GridItem key={file.name}>
          <Thumbnail
            src={URL.createObjectURL(file)}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = '/assets/img/file.png';
            }}
          />

          <DeleteIconContainer
            onClick={() => {
              setAttachments(attachments.filter((k) => k.name !== file.name));
            }}
          >
            <CloseCircle />
          </DeleteIconContainer>

          <FileNameContainer>{file.name}</FileNameContainer>
        </GridItem>
      </>
    );
  };

  function standardValidate () {
    if (standards && standards.length <= 0) {
      setConfirmProceedWithoutAssessmentModal(true);
    } else {
      handleSubmit();
    }
  }

  const category =
    focusAreaOptions &&
    focusAreaOptions.categories &&
    selectedFocusArea &&
    focusAreaOptions.categories.find(
      (focusArea) =>
        focusArea.categoryId.toString() === selectedFocusArea.toString() &&
        focusArea.visit === selectedVisit
    );
  let opt = category ? category.missedStandards : undefined;

  function toggleConfirmProceedModal () {
    setConfirmProceedWithoutAssessmentModal(
      !isConfirmProceedWithoutAssessmentModal
    );
  }

  function toggleAttachFileModal () {
    setAttachFileModal(!isAttachFileModal);
  }

  function focusAreaCallback (event) {
    if (!event.value) {
      setMissedStandards([]);
      setStandards([]);
      setSelectedFocusArea(undefined);
      setSelectedVisit(1);
      return;
    }
    const cat = event.value.split('#$#');
    setSelectedFocusArea(parseInt(cat[0]));
    setSelectedVisit(parseInt(cat[1]));
    formChangeHandler();
  }

  return (
    <>
      <HeaderContainer>
        <AppHeader title={t('COMMON.MY_ACTIONS.ACTIONS.ACTION_PLAN')} />
      </HeaderContainer>
      {assessments.length <= 0 ? (
        <ContentArea>
          <div className="m-10 mt-20">
            <div className="box-shadow d-block mb-10">
              <Skeleton
                containerClassName="flex-1"
                height={100}
                borderRadius={5}
              />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div>
              <Skeleton width={80} height={30} borderRadius={5} />
              <Skeleton width={350} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <Skeleton
              containerClassName="flex-1"
              height={50}
              borderRadius={5}
            />
          </div>
        </ContentArea>
      ) : (
        <ContentArea>
          <Borderbox>
            <OwnerTable className="addActionPlanForm">
              <tr>
                <td>
                  <Body6 color="eerieBlack">Owner</Body6>
                </td>
                <td>{`${userData.user.userLastName.charAt(0).toUpperCase() + userData.user.userLastName.slice(1)}, ${userData.user.userFirstName.charAt(0).toUpperCase() + userData.user.userFirstName.slice(1)}`}</td>
              </tr>
              <tr>
                <td>
                  <Body6 color="eerieBlack">
                    <RequiredIcon color="redCrayola">*</RequiredIcon>Assigned To
                  </Body6>
                </td>
                <td>
                  <SearchBoxActionPlanUsers
                    callBackSelectedOptions={handleAssignees}
                    disabled={false}
                  />
                </td>
              </tr>
            </OwnerTable>
          </Borderbox>
          <AssessmentTypeTable className="addActionPlanForm">
            <tr>
              <td>
                <Body6 color="eerieBlack">
                  <RequiredIcon color="redCrayola">*</RequiredIcon>Assessment
                  Type:
                </Body6>
              </td>
              <td>
                <ControlSelect
                  className={`${errorState.assessmentType ? 'red-border' : ''}`}
                  layout="pillbutton"
                  value={assessmentType}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    setAssessmentType(selectedValue);
                    setSelectedFocusArea(undefined);
                    setSelectedTemplateId(undefined);
                    setSelectedAssessment(undefined);
                  }}
                  disabled={false}
                >
                  <option key={1} value={'LQA'}>
                    {'LQA'}
                  </option>
                  {reservationPresent && (
                    <option key={2} value={'reservation'}>
                      {AssessmentType.reservation}
                    </option>
                  )}
                  {selfAssessmentId && (
                    <option key={3} value={'self'}>
                      {'Self'}
                    </option>
                  )}
                </ControlSelect>
              </td>
            </tr>
            <tr>
              <td>
                <Body6 color="eerieBlack">Status</Body6>
              </td>
              <td>
                <TextPill>New</TextPill>
              </td>
            </tr>
            <tr>
              <td>
                <Body6 color="eerieBlack">Attachments:</Body6>
              </td>
              <td>
                <ImageResizeBasic
                  onImageCompletion={(file) => {
                    setAttachments((prevState) => [...prevState, file]);
                  }}
                  uploadImageComponent={
                    <AddAttachmentsText>Add Attachments</AddAttachmentsText>
                  }
                />
                <input
                  ref={inputRef}
                  type="file"
                  multiple={true}
                  accept="application/pdf,text/*,image/*,.xls,.xlsx,.doc,.docx,video/mp4,video/x-m4v,video/*,audio/*"
                  className="d-none"
                  onChange={(e) => {
                    if (e && e.target && e.target.files && e.target.files[0]) {
                      const file = e.target.files[0];
                      setAttachments((prevState) => [...prevState, file]);
                    }
                    inputRef.current.value = null;
                  }}
                />
              </td>
            </tr>
            {attachments && attachments.length > 0 && (
              <tr>
                <td colSpan={2}>
                  <GridContent>
                    {attachments &&
                      attachments.length > 0 &&
                      attachments.map((file, index) => (
                        <ImageOverlay
                          key={index}
                          images={getImages(file)}
                          target={
                            <span key={index + 'attachments'}>
                              {AttachmentContainer(file)}
                            </span>
                          }
                        />
                      ))}
                  </GridContent>
                </td>
              </tr>
            )}
          </AssessmentTypeTable>
          <Table className="addActionPlanForm">
            <tr>
              <td>
                <Body6 color="eerieBlack">Assessment:</Body6>
              </td>
              <td>
                {selfAssessmentId ? (
                  <label>
                    {selfStayStart &&
                      moment(selfStayStart.toString()).format('Do MMM YY')}
                  </label>
                ) : (
                  <ControlSelect
                    key={'selectedAssessment'}
                    value={
                      selfAssessmentId
                        ? selfAssessmentId.toString()
                        : selectedAssessment
                          ? selectedAssessment.toString()
                          : WithoutAssessment.NoAssessmentAdded
                    }
                    onChange={(e) => {
                      if (
                        e.target.value === WithoutAssessment.NoAssessmentAdded
                      ) {
                        setSelectedAssessment(undefined);
                        setSelectedTemplateId(undefined);
                        setSelectedFocusArea(undefined);
                        setSelectedVisit(1);
                        setIsDefault(true);
                        return;
                      }
                      setIsDefault(false);
                      const assessmentId = e.target.value || '';
                      const templateId =
                        e.target.value && assessments
                          ? assessments.results.find(
                            (o) => o.id === parseInt(assessmentId)
                          )!.template.id
                          : '';
                      setSelectedAssessment(assessmentId);
                      setSelectedTemplateId(templateId);
                      setSelectedFocusArea(undefined);
                      setSelectedVisit(1);
                      formChangeHandler();
                    }}
                  >
                    {selfAssessmentId && (
                      <option
                        key={selfAssessmentId}
                        value={selfAssessmentId.toString()}
                      >
                        {moment(selfStayStart.toString()).format('Do MMM YY')}
                      </option>
                    )}
                    {!selfAssessmentId &&
                      assessments &&
                      assessments.results &&
                      assessments.results
                        .filter((o) => o.assessmentType === assessmentType)
                        .map((assessment) => (
                          <option
                            key={assessment.id}
                            value={assessment.id.toString()}
                          >
                            {moment(assessment.stayStart).format('Do MMM YY')}
                          </option>
                        ))}
                    <option value={WithoutAssessment.NoAssessmentAdded}>
                      {getWithoutAssessmentLabel(
                        WithoutAssessment.NoAssessmentAdded
                      )}
                    </option>
                  </ControlSelect>
                )}
              </td>
            </tr>
            <tr>
              <td>
                <Body6 color="eerieBlack">
                  <RequiredIcon color="redCrayola">*</RequiredIcon>Standard:
                </Body6>
              </td>
              <td>
                <ControlSelect
                  value={selectedStandardType}
                  onChange={(e) => {
                    setSelectedStandardType(e.target.value);
                    formChangeHandler();
                    setSelectedFocusArea(undefined);
                    setSelectedVisit(1);
                  }}
                >
                  {customStandardTypes && customStandardTypes.map((customStandardType, index) => (
                    <option
                      key={index}
                      value={customStandardType.customScoreType}
                    >
                      {customStandardType.customScoreName}
                    </option>
                  ))}
                </ControlSelect>
              </td>
            </tr>
          </Table>
          <Table className="addActionPlanForm">
            <tr>
              <td>
                <Body6 color="eerieBlack">Focus Area:</Body6>
              </td>
              <td>
                <FocusAreaSelect
                  focusAreaOptions={focusAreaOptions}
                  selectedFocusArea={selectedFocusArea}
                  visit={selectedVisit}
                  focusAreaCallback={focusAreaCallback}
                  isDisabled={false}
                />
              </td>
            </tr>
          </Table>
          <table className="addActionPlanForm">
            <tr>
              <td>
                <Body6 color="eerieBlack">Standard:</Body6>
              </td>
            </tr>
          </table>
          <table className="addActionPlanForm grey-bg">
            <tr>
              <td colSpan={2}>
                <StandardMultiSelect
                  className={`standard-multi-select ${errorState.missedStandards ? 'red-border' : ''}`}
                  options={uniqBy(opt, 'standardId')}
                  selected={uniqBy(
                    [
                      ...standards,
                      ...(opt ? opt.filter((o) => o.selected === true) : []),
                    ],
                    'standardId'
                  )}
                  missedStandards={
                    opt ? opt.filter((o) => o.selected === true) : []
                  }
                  onChange={(stds) => {
                    formChangeHandler();
                    setStandards(stds);
                    setMissedStandards(
                      stds.map((standard) => {
                        opt = opt.map((o) => {
                          if (o.standardId !== standard.standardId) {
                            o.selected = false;
                          }
                          return o;
                        });

                        return {
                          standardId: standard.standardId,
                          categoryId: standard.categoryId,
                        };
                      })
                    );
                  }}
                  placeholder={'Start typing to select…'}
                  disabled={false}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="standard-tag">
                {selectedFocusArea && (
                  <Tags
                    data={uniqBy(
                      [
                        ...standards,
                        ...(opt ? opt.filter((o) => o.selected === true) : []),
                      ],
                      'standardId'
                    )}
                    onRemove={(tag) => {
                      setStandards(
                        uniqBy(
                          [
                            ...standards,
                            ...(opt
                              ? opt.filter((o) => o.selected === true)
                              : []),
                          ],
                          'standardId'
                        ).filter(
                          (existing) => existing.standardId !== tag.standardId
                        )
                      );
                      setMissedStandards(
                        uniqBy(
                          [
                            ...standards,
                            ...(opt
                              ? opt.filter((o) => o.selected === true)
                              : []),
                          ],
                          'standardId'
                        )
                          .filter(
                            (existing) => existing.standardId !== tag.standardId
                          )
                          .map((standard) => {
                            opt = opt.map((o) => {
                              if (o.standardId !== standard.standardId) {
                                o.selected = false;
                              }
                              return o;
                            });

                            return {
                              standardId: standard.standardId,
                              categoryId: standard.categoryId,
                            };
                          })
                      );
                    }}
                  />
                )}
              </td>
            </tr>
          </table>
          <Table className="addActionPlanForm">
            <tr>
              <td>
                <Body6 color="eerieBlack">
                  <RequiredIcon color="redCrayola">*</RequiredIcon>Action:
                </Body6>
              </td>
              <td>
                <ControlSelect
                  className={` ${errorState.actionPlanType ? 'red' : ''}`}
                  value={actionPlanType || ''}
                  onChange={(e) => {
                    setActionPlanType(e.target.value);
                  }}
                >
                  <option value="" />
                  {Object.keys(ActionPlanType).map((value, index) => (
                    <option key={index} value={value}>
                      {translateActionPlanTypeLabel(value as ActionPlanType)}
                    </option>
                  ))}
                </ControlSelect>
              </td>
            </tr>
            <tr>
              <td>
                <Body6 color="eerieBlack">
                  <RequiredIcon color="redCrayola">*</RequiredIcon>Measurement:
                </Body6>
              </td>
              <td>
                <ControlSelect
                  className={` ${errorState.actionPlanMeasurement ? 'red' : ''}`}
                  value={actionPlanMeasurement || ''}
                  onChange={(e) => {
                    formChangeHandler();
                    setActionPlanMeasurement(e.target.value);
                  }}
                >
                  <option value="" />
                  {Object.keys(ActionPlanMeasurementType).map(
                    (value, index) => (
                      <option key={index} value={value}>
                        {translateActionPlanMeasurementTypeLabel(
                          value as ActionPlanMeasurementType
                        )}
                      </option>
                    )
                  )}
                </ControlSelect>
              </td>
            </tr>
          </Table>
          <Table className="addActionPlanForm">
            <tr>
              <td>
                <Body6 color="eerieBlack">
                  <RequiredIcon color="redCrayola">*</RequiredIcon>Due Date:
                </Body6>
              </td>
              <td>
                <DatePicker
                  className={`date-picker ${errorState.dueDate ? 'red-border' : ''} `}
                  dateFormat="dd-MM-yyyy"
                  onFocus={(e) => e.target.blur()}
                  minDate={new Date()}
                  showIcon={true}
                  selected={dueDate ? convertUTCDateDisplay(dueDate) : null}
                  onChange={(selectedDate) => {
                    if (selectedDate) {
                      formChangeHandler();
                      setDueDate(
                        castSelectedDateWithoutConversion(selectedDate)
                      );
                    }
                  }}
                />
              </td>
            </tr>
          </Table>
          <Table className="addActionPlanForm">
            <tr>
              <td>
                <Body6 color="eerieBlack">
                  <RequiredIcon color="redCrayola">*</RequiredIcon>Message Title
                </Body6>
              </td>
              <td>
                <ControlInput
                  className={` ${errorState.messageTitle ? 'red-border' : ''}`}
                  value={messageTitle}
                  maxLength={150}
                  onChange={(e) => {
                    formChangeHandler();
                    setMessageTitle(e.target.value);
                  }}
                />
              </td>
            </tr>
            <tr>
              <td>
                <Body6 color="eerieBlack">
                  <RequiredIcon color="redCrayola">*</RequiredIcon>Message
                  Description
                </Body6>
              </td>
              <td />
            </tr>
            <tr>
              <td colSpan={2}>
                <ControlTextarea
                  minRows={2}
                  value={messageDescription}
                  className={` ${errorState.messageDescription ? 'red-border' : ''}`}
                  onChange={(e) => {
                    setMessageDescription(e.target.value);
                    formChangeHandler();
                  }}
                  placeholder=""
                />
              </td>
            </tr>
          </Table>
          <ButtonBlockColumn>
            <ButtonLarge
              title="Create"
              onClick={standardValidate}
              disabled={isCreating}
              loading={isCreating}
            />
          </ButtonBlockColumn>
        </ContentArea>
      )}
      {isConfirmProceedWithoutAssessmentModal && (
        <Modal
          isOpen={isConfirmProceedWithoutAssessmentModal}
          handleModalClose={toggleConfirmProceedModal}
        >
          <ButtonBlockColumn>
            <ModalTitleContainer>
              <Headline3>
                {t('COMMON.ACTION_PLAN.STANDARD_VALIDATION')}
              </Headline3>
            </ModalTitleContainer>
            <ButtonLarge
              title="Continue"
              onClick={async () => {
                handleSubmit();
              }}
              disabled={isLoading}
            />
            <ButtonLarge
              title="Cancel"
              onClick={() => setConfirmProceedWithoutAssessmentModal(false)}
              outlined={true}
              inverted={true}
            />
          </ButtonBlockColumn>
        </Modal>
      )}
      {isAttachFileModal && actionPlanIds && actionPlanIds.length && (
        <Modal
          isOpen={isAttachFileModal}
          handleModalClose={toggleAttachFileModal}
        >
          <ButtonBlockColumn>
            <ModalTitleContainer>
              <TitleAttachFileModal>
                Action Plan has been created but Unable to attach file
              </TitleAttachFileModal>
              <Body5>
                Action Plan has been created but Unable to attach file
              </Body5>
            </ModalTitleContainer>
            <ButtonLarge
              title="Proceed"
              onClick={async () => {
                setItem('isFormData', false);
                navigate(
                  `/editActionPlan/from-individual/sent/${actionPlanIds[0]}`
                );
              }}
            />
          </ButtonBlockColumn>
        </Modal>
      )}
    </>
  );
};

export default CreateActionPlan;
